// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** ThemeConfig Import
import themeConfig from '@configs/themeConfig'
import { setCookieWithExpiry } from '../utility/Utils'

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem('menuCollapsed')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed
}

const initialDirection = () => {
  const item = window.localStorage.getItem('isRTL')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.isRTL
}

const initialSkin = () => {
  const item = window.localStorage.getItem('skin')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.skin
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    skin: initialSkin(),
    isRTL: initialDirection(),
    direction: "rtl",
    layout: themeConfig.layout.type,
    lastLayout: themeConfig.layout.type,
    menuCollapsed: initialMenuCollapsed(),
    footerType: themeConfig.layout.footer.type,
    navbarType: themeConfig.layout.navbar.type,
    menuHidden: themeConfig.layout.menu.isHidden,
    contentWidth: themeConfig.layout.contentWidth,
    routerTransition: themeConfig.layout.routerTransition,
    navbarColor: themeConfig.layout.navbar.backgroundColor,
    installModal: true,
    setpModal: 1,
    chartSidebar: false,
    socket:null,
    currency: JSON.parse(window.localStorage.getItem('activeCurrency')) || { symbol: 'BTC', name: 'Bitcoin', min_amount: 0.0005, labels: { fa: 'بیت کوین', en: 'Bitcoin' } }
  },
  reducers: {
    handelSaveActiveCurrency: (state, action) => {
      state.currency = action.payload
    },
    handelSocket: (state, action) => {
      console.log(action)
      state.socket = action.payload
    },
    handelChartSidebar: (state, action) => {
      console.log(action.payload)
      state.chartSidebar = action.payload
    },
    handleRTL: (state, action) => {
      state.isRTL = action.payload.isRTL
      state.direction = action.payload.direction
      window.localStorage.setItem('isRTL', JSON.stringify(action.payload.isRTL))
      window.localStorage.setItem('direction', JSON.stringify(action.payload.direction))
    },
    handleSkin: (state, action) => {
      state.skin = action.payload
      window.localStorage.setItem('skin', JSON.stringify(action.payload))
    },
    handleLayout: (state, action) => {
      state.layout = action.payload
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload
    },
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload
      window.localStorage.setItem('menuCollapsed', JSON.stringify(action.payload))
    },
    handleRouterTransition: (state, action) => {
      state.routerTransition = action.payload
    },
    handelInstall: (state, action) => {
      state.setpModal = +window.localStorage.getItem('showInstallModalStep') + 1
      window.localStorage.setItem('showInstallModalStep', JSON.stringify(state.setpModal))

      if (+window.localStorage.getItem('showInstallModalStep') < 3 && action.payload.method !== 'install') {
        state.installModal = action.payload.status
        return
      }
      if (+window.localStorage.getItem('showInstallModalStep') === 3) {
        state.installModal = action.payload.status
        setCookieWithExpiry('installitionsMode', action.payload.status, 10080)
      }
      if (action.payload.method === 'install') {
        state.installModal = false
        setCookieWithExpiry('installitionsMode', action.payload.status, 10080)
        return
      }
      if (state.setpModal > 3) {
        setCookieWithExpiry('installitionsMode', action.payload.status, 10080)
      }
    }
  }
})

export const {
  handelSaveActiveCurrency,
  handelChartSidebar,
  handleRTL,
  handleSkin,
  handleLayout,
  handleLastLayout,
  handleMenuHidden,
  handleNavbarType,
  handleFooterType,
  handleNavbarColor,
  handleContentWidth,
  handleMenuCollapsed,
  handleRouterTransition,
  handelInstall,
  handelSocket
} = layoutSlice.actions

export default layoutSlice.reducer
